'use strict'

/**
 * Module qui va afficher des images en lazy loading
 */

import tools from 'Modules/tools'

const J_DATA_LAZY_LOADING = 'srclazyloading'
const J_LAZY_LOADING = '.j_lazy_loading'
const J_LAZY_LOADING_PANEL = '.j_lazy_panel'

/*
 * Set l'événement pour charger les images au scroll
 */
function setEvent() {
    $(window).scroll(printImage)
    $(J_LAZY_LOADING_PANEL).scroll(printImage)
}

/*
 * Fonction d'affichage des images : Si elles sont dans la partie visibile de la page sur l'écran, on les charges.
 */
function printImage() {
    const $images = $(J_LAZY_LOADING + '[data-' + J_DATA_LAZY_LOADING + "!='']")

    $images.each(function (index, image) {
        if (document.getElementsByClassName('j_custom_slide').length > 0) {
            $(image)[0].src = $(image)[0].getAttribute('data-srclazyloading')
        }
        if (tools.isElementInViewport(image)) {
            const src = $(image).data(J_DATA_LAZY_LOADING)
            if (src !== undefined && src !== '') {
                const img = new Image()
                img.onload = function () {
                    $(image).replaceWith(img)
                }

                img.src = src
                img.width = 176
                img.height = 242
                img.className = 'img-responsive'
                $(image).data(J_DATA_LAZY_LOADING, '')
            }
        }
    })
}

export default {
    setEvent: setEvent,
    printImage: printImage
}
